import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RepeatIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M10.9798 0.979821C11.1751 0.784558 11.4916 0.784558 11.6869 0.979821L14.3538 3.64681C14.5488 3.8421 14.549 4.15869 14.3538 4.35384L11.6869 7.01986C11.4916 7.21512 11.1751 7.21512 10.9798 7.01986C10.7847 6.82458 10.7846 6.50804 10.9798 6.31283L13.2923 3.99935L10.9798 1.68685C10.7846 1.49159 10.7846 1.17508 10.9798 0.979821Z"
      fill="currentColor"
    />
    <path
      d="M1.5 7.33301V6.66699C1.5 5.82714 1.83387 5.0216 2.42773 4.42773C3.0216 3.83387 3.82714 3.5 4.66699 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4C14.5 4.27614 14.2761 4.5 14 4.5H4.66699C4.09236 4.5 3.54109 4.72844 3.13477 5.13477C2.72844 5.54109 2.5 6.09236 2.5 6.66699V7.33301C2.5 7.60915 2.27614 7.83301 2 7.83301C1.72386 7.83301 1.5 7.60915 1.5 7.33301Z"
      fill="currentColor"
    />
    <path
      d="M4.31348 8.97982C4.50875 8.78472 4.8253 8.78461 5.02051 8.97982C5.21556 9.17504 5.21556 9.49163 5.02051 9.68685L2.70703 11.9993L5.02051 14.3128C5.21566 14.508 5.21545 14.8246 5.02051 15.0199C4.82525 15.2151 4.50874 15.2151 4.31348 15.0199L1.64649 12.3538C1.45128 12.1586 1.45139 11.8421 1.64649 11.6468L4.31348 8.97982Z"
      fill="currentColor"
    />
    <path
      d="M13.5 9.33366V8.66666C13.5 8.39052 13.7239 8.16666 14 8.16666C14.2761 8.16666 14.5 8.39052 14.5 8.66666V9.33366C14.4999 10.1734 14.1661 10.9791 13.5723 11.5729C12.9784 12.1666 12.1727 12.4997 11.333 12.4997H2C1.72386 12.4997 1.5 12.2758 1.5 11.9997C1.50018 11.7237 1.72397 11.4997 2 11.4997H11.333C11.9075 11.4997 12.4589 11.272 12.8652 10.8659C13.2715 10.4596 13.4999 9.90817 13.5 9.33366Z"
      fill="currentColor"
    />
  </svg>
);
